import { Badge } from '@/components/ui/badge';

/**
 * Test Mode Badge - Shows when PAYMENT_MODE=test
 * Only visible in development or when explicitly enabled
 */
export default function TestModeBadge() {
  const isTestMode = import.meta.env.PAYMENT_MODE === 'test';
  const isDev = import.meta.env.DEV;

  if (!isTestMode && !isDev) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50">
      <Badge variant="destructive" className="text-xs font-mono">
        {isTestMode ? 'TEST MODE' : 'DEV MODE'}
      </Badge>
    </div>
  );
}
